import React, { useState } from 'react';
import cn from "classnames";
import OutsideClickHandler from 'react-outside-click-handler';
import { Tooltip } from '../UI/Tooltip/Tooltip';
import CheckBox from '../UI/Checkbox/CheckBox';
import tableSettingsIcon from "../../images/table-settings.svg";

import "./TabelSettings.sass";

export const TabelSettings = ({ checkboxesList, checkedColumns, toggleColumn }) => {
  const [isTableSettingsShown, setTableSettingsShown] = useState(false);
  const toggleTableSettings = () => {
    setTableSettingsShown(prev => !prev);
  };

  const closeTableSettings = () => {
    if (isTableSettingsShown) {
      setTableSettingsShown(false);
    }
  };

  return (
    <OutsideClickHandler onOutsideClick={closeTableSettings}>
      <div className="table-settings">
        <Tooltip
          description="Table settings"
          className="table-settings__icon"
          onClick={toggleTableSettings}
        >
          <img src={tableSettingsIcon} alt="Settings" />
        </Tooltip>
        <div className={cn("table-settings__checkboxes-container", {
          "table-settings__checkboxes-container--hidden": !isTableSettingsShown,
        })}>
          {checkboxesList.map((c) => (
            <CheckBox
              key={c}
              checked={checkedColumns.includes(c)}
              id={c}
              name={c}
              isDisabled={checkedColumns.length === 1 && checkedColumns.includes(c)}
              onChange={() => toggleColumn(c)}>
              <span className="input-behavior">
                {c}
              </span>
            </CheckBox>
          ))}
        </div>
      </div>
    </OutsideClickHandler>
  )
}
